import React from 'react';
import { CheckIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CTAButton, PRICE_ANCHOR_ID } from '../CTAButton';
import { ImageSlot } from '../ImageSlot';
import { offerItems } from '../../data/landing';
export function OfferSection() {
  return <Section tone="ink" data-id="element-116" data-mp="ahrv8s3d9scj">
      <SectionTitle className="text-center" data-id="element-117" data-mp="aia36lze5v0a">Todo lo que te llevas en INOLVIDABLE</SectionTitle>

      <ImageSlot name="Kit del curso INOLVIDABLE con Beatriz Espina" aspect="aspect-[3/2]" src="https://cdn.magicpatterns.com/uploads/wd26vdsErdV6HvkmFitXeT/Kit_de_Curso_Inolvidable_con_Beatriz_Espina.png" className="mt-12" data-id="element-118" data-mp="6irdlcwmkvr4" />

      <ul className="mt-12 space-y-5" data-id="element-119" data-mp="3nyhe3g2eihww">
        {offerItems.map(item => <li key={item} className="flex gap-4 text-[17px] leading-relaxed text-ivory" data-id="element-120" data-mp="3iyd8il3177lg">
            <CheckIcon aria-hidden="true" strokeWidth={1.5} className="mt-1 h-5 w-5 shrink-0 text-gold" data-id="element-121" data-mp="3ex01i7o7cycy" />
            <span data-id="element-122" data-mp="1as0o664dnp1j">{item}</span>
          </li>)}
      </ul>

      <div className="mt-12 flex gap-4 rounded-xl border border-gold bg-gold/10 p-5" data-id="element-123" data-mp="1aqpl68iralbh">
        <GiftIcon aria-hidden="true" strokeWidth={1.25} className="mt-0.5 h-6 w-6 shrink-0 text-gold" data-id="element-124" data-mp="1fkbnb6ran6t1" />
        <p className="text-base leading-relaxed text-ivory" data-id="element-125" data-mp="10vfidikja9wn">
          <strong className="font-semibold text-gold" data-id="element-126" data-mp="15s5w3z8v8tew">Bonus para los primeros 20:</strong> Reto Inolvidable. 4 semanas
          guiadas por la DOC, una zona por semana.
        </p>
      </div>

      <div id={PRICE_ANCHOR_ID} className="mx-auto mt-14 max-w-[440px] scroll-mt-16 rounded-2xl border border-gold bg-wine px-8 py-10 text-center" data-id="element-127" data-mp="1yi4qma5txiqy">
        <p className="font-serif text-2xl italic text-ivory" data-id="element-128" data-mp="1kk6b31frvg9v">Pack INOLVIDABLE</p>
        <p className="mt-3 font-serif text-[4.5rem] font-medium leading-none text-gold" data-id="element-129" data-mp="1ohm0wyrl3814">$17 USD</p>
        <p className="mt-4 text-[13px] uppercase tracking-[0.2em] text-ivory/75" data-id="element-130" data-mp="91dh74xo57ep">Pago único</p>
      </div>

      <div className="mt-10 text-center" data-id="element-131" data-mp="d25ovtqw748v">
        <CTAButton toCheckout data-id="element-132" data-mp="2fr6yq3tdq22u" />
      </div>

      <div className="mx-auto mt-10 flex max-w-[480px] items-start justify-center gap-3 text-left" data-id="element-133" data-mp="2fq5lptssz5ih">
        <ShieldCheckIcon aria-hidden="true" strokeWidth={1.25} className="h-8 w-8 shrink-0 text-gold" data-id="element-134" data-mp="2asm72ss70qq0" />
        <p className="text-[15px] leading-relaxed text-ivory/90" data-id="element-135" data-mp="25z1930qlnwqt">
          <span className="font-semibold text-gold" data-id="element-136" data-mp="2119hk7tvacn5">Garantía de 7 días.</span> Si no es para ti, Hotmart te devuelve el
          100%.
        </p>
      </div>
      <p className="mt-5 text-center text-sm text-ivory/60" data-id="element-137" data-mp="1s1cq5yg3ezoe">Pago seguro por Hotmart.</p>
    </Section>;
}